import React, { useEffect, useState } from "react"
import { Button, Col, Container, Modal, ModalBody, Row } from "reactstrap"

import CommissionEarnedChart from "pages/Dashboard/WealthPartnerDashboard/CommissionEarnedChart"
import WealthPartnerDashboardStats from "./WealthPartnerDashboardStats"
import AdminOffersCards from "./AdminOffersCards"
import CompanyAgreementsList from "./CompanyAgreementsList"
import TopPerfomer from "./TopPerfomer"
import ReferralTracking from "./ReferralTracking"
import MaturityTracking from "./MaturityTracking"
import { useDispatch, useSelector } from "react-redux"
import { useLazyGetWealthPartnerProfileQuery } from "store/api/wealthpartnerapi/auth/auth.api"

import greenCheckIcon from "../../../assets/images/icons/green-check-fill.svg"
import grayCheckIcon from "../../../assets/images/icons/gray-cricel.svg"
import ICDAgreementBox from "../icdAgreementBox"
import { Link } from "react-router-dom"
import ResolveQueryBox from "../ResolveQueryBox"
import { setLoginUserData } from "store/slices/userSlice"
import { useLazyGetKycDataQuery } from "store/api/kyc/kyc"

const getSteps = (entityType, userType, kycData) => {
  if (entityType !== "COMPANY") {
    return [
      {
        label: "Phone Verification",
        key: ["PHONE_VERIFICATION"],
        type: "step",
      },
      {
        label: "ID Verification",
        key: ["ID_VERIFICATION"],
        type: "step",
      },
      {
        label: "Additional Details",
        key: ["ADDITIONAL_DETAILS"],
        type: "step",
      },
      {
        label:
          userType === "INVESTOR" ? "Bank Verification" : "Bank Verification",
        key: ["BANK_VERIFICATION", "BANK_DETAILS"],
        type: "step",
      },
      {
        label: "",
        key: ["SUBMITTED", "FINAL_STEP"],
        type: "final",
      },
    ]
  }

  return [
    {
      label: "Phone Verification",
      key: ["PHONE_VERIFICATION"],
      type: "step",
    },
    {
      label: "Proof of Identity",
      key: ["PAN_GST", "GST_DETAILS", "GST_WAIVER"],
      type: "step",
    },
    ...(kycData?.businessAdditionalDetails?.constitution_of_business !==
      "Hindu Undivided Family"
      ? [
        {
          label: "Additional Details",
          key: ["BUSINESS_ADDITIONAL_DETAILS"],
          type: "step",
        },
      ]
      : []),
    {
      label:
        userType === "INVESTOR" ? "Bank Verification" : "Bank Verification",
      key: ["BANK_VERIFICATION", "BANK_DETAILS"],
      type: "step",
    },
    {
      label: "Authorised<br/>Person KYC",
      key: ["AUTHORISED_SIGNATORY", "ID_VERIFICATION"],
      type: "step",
    },
    {
      label: "Upload <br/>Authority Letter",
      key: ["AUTHORITY_LETTER"],
      type: "step",
    },
    {
      label: "",
      key: ["SUBMITTED", "FINAL_STEP"],
      type: "final",
    },
  ]
}

const WealthPartnerDashboard = () => {
  const { user, userType } = useSelector((state) => state.user)
  const [steps, setSteps] = useState([])
  const [showKycSteps, setShowKycSteps] = useState(false)
  const [getProfile, { isLoading }] = useLazyGetWealthPartnerProfileQuery()
  const dispatch = useDispatch()
  const [openKyc, setOpenKyc] = useState(false)
  const [kycData, setKycData] = useState(null)
  const [getResult, { isFetching }] = useLazyGetKycDataQuery()

  useEffect(() => {
    onGetProfile()
  }, [])

  const onGetProfile = async () => {
    try {
      const { data, success } = await getProfile().unwrap()
      if (success) {
        dispatch(
          setLoginUserData({
            user: data,
          })
        )
      }
    } catch (error) { }
  }

  useEffect(() => {
    getKycData()
  }, [])

  const getKycData = async () => {
    try {
      const { success, message, data } = await getResult().unwrap()
      if (success) {
        setKycData(data)
      }
    } catch (error) {
      // toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  useEffect(() => {
    if ((user, userType)) {
      const initialSteps = getSteps(user.entity_type, userType, kycData)
      const currentStepKey = user.kyc_status

      const currentIndex = initialSteps.findIndex(
        (step) => step.key && step.key.includes(currentStepKey)
      )

      const updatedSteps = initialSteps.map((item, index) => {
        const prevStepIndex = index - 1
        if (prevStepIndex < currentIndex) {
          return { ...item, icon: greenCheckIcon }
        } else {
          return { ...item, icon: grayCheckIcon }
        }
      })

      setSteps([...updatedSteps.filter((item) => item.label)])

      const currentStatus = user.status

      setShowKycSteps(!["APPROVED", "REJECTED"].includes(currentStatus))
      setOpenKyc(user?.status !== "APPROVED")
    }
  }, [user, userType])

  return (
    <React.Fragment>
      <Container fluid>
        <Row>
          <Col xl={12}>
            <div className="container-wrapper-box">
              <div className="container-wrapper-left-box">
                <WealthPartnerDashboardStats />
                <AdminOffersCards />
                <CompanyAgreementsList />
                <div className="chart-section-wrapper">
                  <CommissionEarnedChart />
                </div>
              </div>
              <div className="container-wrapper-right-box">
                <TopPerfomer />
                <ReferralTracking />
                <MaturityTracking />
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      {user?.status === "ICD_AGREEMENT" ? (
        <ICDAgreementBox
          template_type="ICD_AGREEMENT"
          icd_id=""
          open={openKyc}
          setOpen={setOpenKyc}
        />
      ) : (
        <Modal
          isOpen={openKyc}
          toggle={() => setOpenKyc(!openKyc)}
          // backdrop="static"
          // keyboard={false}
          size="sm"
          centered
          style={{
            border: 0,
            minWidth: "350px",
          }}
        >
          <ModalBody
            style={{
              padding: 0,
            }}
          >
            <Row>
              <Col
                xl={12}
                className="investor-dashboard-wrapper"
                style={{
                  display: "block",
                  padding: 0,
                }}
              >
                <div
                  className="investor-card-wrapper"
                  style={{
                    display: "block",
                    padding: 0,
                  }}
                >
                  {user?.status === "QUERY_RAISED" ? (
                    <ResolveQueryBox />
                  ) : (
                    <>
                      {showKycSteps && (
                        <div className="start-investing-section">
                          {user?.status === "UNDER_REVIEW" ? (
                            <>
                              <h2>KYC Under Review</h2>
                              <h3>
                                Your KYC is under review. We're verifying your
                                details to ensure security and compliance.
                                You'll be notified once the review is complete.
                              </h3>
                            </>
                          ) : (
                            <>
                              <h2>Get Verified to Start Investing</h2>
                              <h3>
                                Complete your KYC in just a few steps to access
                                all features securely and stay compliant.
                              </h3>
                            </>
                          )}
                          <div className="investor-steps-box-wrapper">
                            {steps.map((item, index) => (
                              <React.Fragment key={`steps_${index}`}>
                                <div className="step-section-inner-box">
                                  <div className="step-section-title">
                                    <img
                                      height={"20px"}
                                      src={item.icon}
                                      alt=""
                                    />
                                    <h6
                                      dangerouslySetInnerHTML={{
                                        __html: item.label,
                                      }}
                                    ></h6>
                                  </div>
                                  <p>Step {index + 1}</p>
                                </div>
                              </React.Fragment>
                            ))}
                          </div>
                          {user?.status === "UNDER_REVIEW" ? (
                            <Link to={"/kyc"}>
                              <Button className="btn btn-primary">
                                KYC Under Review
                              </Button>
                            </Link>
                          ) : (
                            <Link to={"/kyc"}>
                              <Button className="btn btn-primary">
                                Complete KYC Now
                              </Button>
                            </Link>
                          )}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      )}
    </React.Fragment>
  )
}

export default WealthPartnerDashboard
